<template>
  <div v-if="visible" class="details-container" :style="{ height: height + 'px' }">
    <!-- TOP RESIZE HANDLE -->
    <div class="resize-handle" @mousedown="startResize"></div>

    <header class="modal-header">
      <div class="flex">
        <div class="basis-3/4 flex justify-start gap-3 text-sm">
          <p class="text-white">{{ detailsTitle }}</p>
        </div>
        <div class="basis-1/4 flex justify-end">
          <button @click="hideDetails"> <i class="fa fa-window-close"></i></button>
        </div>
      </div>
    </header>

    <div class="modal-body">
      <slot name="detailSlot"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeUnmount } from 'vue';

const props = defineProps({
  visible: Boolean,
  detailsTitle: String,
});

const emit = defineEmits(['hideDetails']);

const height = ref(200); // default height
let startY = 0;
let startHeight = 0;

const startResize = (e) => {
  startY = e.clientY;
  startHeight = height.value;

  document.addEventListener('mousemove', resize);
  document.addEventListener('mouseup', stopResize);
};

const resize = (e) => {
  const delta = startY - e.clientY; // moving UP increases height
  height.value = Math.max(150, startHeight + delta);
};

const stopResize = () => {
  document.removeEventListener('mousemove', resize);
  document.removeEventListener('mouseup', stopResize);
};

onBeforeUnmount(stopResize);

const hideDetails = () => {
  emit('hideDetails');
};
</script>

<style scoped>
.details-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  border-top: 2px solid #6A7C8F;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Resize handle */
.resize-handle {
  height: 4px;
  cursor: ns-resize;
  background: #94a3b8;
}

.modal-header {
  padding: 2px;
  background: #6A7C8F;
}

.modal-body {
  height: calc(100% - 40px);
  overflow-y: auto;
}
</style>
